// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 38" enableBackground="new 0 0 42 38" xmlSpace="preserve">
<g fill="currentColor">
	<path d="M35.58,10.67H6.42c-3.46,0-6.25,2.79-6.25,6.25v12.5H8.5v8.33h25v-8.33h8.33v-12.5C41.83,13.46,39.04,10.67,35.58,10.67z
		 M29.33,33.58H12.67V23.17h16.67V33.58z M35.58,19c-1.15,0-2.08-0.94-2.08-2.08s0.94-2.08,2.08-2.08c1.15,0,2.08,0.94,2.08,2.08
		S36.73,19,35.58,19z"/>
	<rect x="8.5" y="0.25" width="25" height="8.33"/>
</g>
</svg>;
};

export default React.memo(Print);
